import { render, staticRenderFns } from "./checkJoin.vue?vue&type=template&id=475bd4ac&scoped=true&"
import script from "./checkJoin.vue?vue&type=script&lang=js&"
export * from "./checkJoin.vue?vue&type=script&lang=js&"
import style0 from "./checkJoin.vue?vue&type=style&index=0&id=475bd4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475bd4ac",
  null
  
)

export default component.exports